export const SET_USER_DATA = 'SET_USER_DATA';

export const SET_ORGANIZATION_DATA = 'SET_ORGANIZATION_DATA';

export const SET_DEMO_DATA = 'SET_DEMO_DATA';

export const SET_PROGRESS_BAR_DATA = 'SET_PROGRESS_BAR_DATA';
export const ADD_COMPLETION_AND_POINTS_TO_PROGRESS_BAR = 'ADD_COMPLETION_AND_POINTS_TO_PROGRESS_BAR';

export const SET_TILES_DATA = 'SET_TILES_DATA';
export const SET_TILES_STATE = 'SET_TILES_STATE';
export const UPDATE_TILE_DATA = 'UPDATE_TILE_DATA';
export const ADD_TILES_TO_STORE = 'ADD_TILES_TO_STORE';

export const SET_TILES_PER_ROW = 'SET_TILES_PER_ROW';

export const SET_EDIT_DATE = 'SET_EDIT_DATE';

export const SET_ACTIVE_STATUS = 'SET_ACTIVE_STATUS';
export const SET_IS_USER_SITE_ADMIN = 'SET_IS_USER_SITE_ADMIN';
export const SET_ALERT = 'SET_ALERT';
export const SET_FILTERS = 'SET_FILTERS';
export const SET_AUDIENCES = 'SET_AUDIENCES';
export const ADD_AUDIENCE = 'ADD_AUDIENCE';
export const UPDATE_AUDIENCE = 'UPDATE_AUDIENCE';
export const REMOVE_AUDIENCE = 'REMOVE_AUDIENCE';
export const REMOVE_TOPIC = 'REMOVE_TOPIC';
export const SET_TOPICS = 'SET_TOPICS';
export const ADD_TOPIC = 'ADD_TOPIC';
export const SET_POPULATION_SEGMENTS = 'SET_POPULATION_SEGMENTS';

export const SET_BUCKETS = 'SET_BUCKETS';
export const UPDATE_BUCKET_TILES = 'UPDATE_BUCKET_TILES';
export const SET_TILES = 'SET_TILES';
export const REMOVE_TILE = 'REMOVE_TILE';
export const REMOVE_TILES = 'REMOVE_TILES';
export const TOGGLE_TILE_LOADING = 'TOGGLE_TILE_LOADING';
export const TOGGLE_TILE_IGNORE = 'TOGGLE_TILE_IGNORE';

export const MOVE_TILES_TO_STATE = 'MOVE_TILES_TO_STATE';
export const COPY_TILE = 'COPY_TILE';
export const DELETE_TILE = 'DELETE_TILE';
export const UPDATE_TILE = 'UPDATE_TILE';

export const SET_CLIENTS = 'SET_CLIENTS';
export const ADD_CLIENT = 'ADD_CLIENT';

export const SET_DRAG_AND_DROP_CONTEXT = 'SET_DRAG_AND_DROP_CONTEXT';
export const INITIALIZE_DRAG_AND_DROP_CONTEXT = 'INITIALIZE_DRAG_AND_DROP_CONTEXT';
